import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import styles from './WpProductDownloadBtn.module.less';
import useLoginStatus, { handleLogin } from '../../utils/hooks/useLoginStatus';
import { createAxios, logNative } from '../../utils/utils';
import { WP_PRODUCT_BUY_STATUS_80 } from '../../config';
import WpProductDetail from './WpProductDetail';
import { PCStoreJsBridge } from '../../nativeapi';
import WpProductDownloadPath from './WpProductDownloadPath';
import Toast from '../Toast/Toast';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
  addDownloadImg,
  updateWpPayDownCount,
  updateShowWpOrder,
  showBatchAddInfo,
} from '../../actions/wallpaper';
import { WP_DOWNLOAD } from '../../constants/storageKeys';
import { logging } from '../../actions/log';
import { useActivate } from 'react-activation';

/**
 * type:1单张壁纸 2壁纸包
 */
const selectWpDownImg = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDowloadImgs,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(
  ({
    className,
    children,
    wallpaper,
    cardInfo,
    logInfo,
    hasDownloading = false,
    size = 'small',
    callback = () => {},
  }) => {
    const loginStatus = useLoginStatus();
    const wpDownloadImgs = useSelector(selectWpDownImg);
    const dispatch = useDispatch();
    const [wpProduct, setWpProduct] = useState({ hasBuy: false, show: false, hasSetPath: true });
    const [isDownloading, setIsDownloading] = useState(false);
    const logInfoData = useSelector(selectLogInfo);
    const [wpTask, setWpTask] = useState({ down: false });

    const failToast = useCallback(() => {
      Toast.error({
        content: '下载失败，请重试！',
      });
    }, []);
    const getBuyStatus = useCallback(async () => {
      let hasbuy = null;
      try {
        const axios = await createAxios('isNeedUser');
        const res = await axios.get(WP_PRODUCT_BUY_STATUS_80, {
          params: {
            type: wallpaper?.type || 1,
            skuId: wallpaper?.type === 2 ? wallpaper?.code : wallpaper?.wallpaperId,
          },
        });
        if (res?.data?.status == 0) {
          setWpProduct(state => ({
            ...state,
            hasBuy: true,
          }));
          hasbuy = 1;
        } else if (res?.data?.status == -1) {
          hasbuy = -1;
        }
      } catch (err) {
        failToast();
        logNative(`请求壁纸${wallpaper?.wallpaperId} 错误${err}`);
      }
      return hasbuy;
    }, [wallpaper]);

    const handelWpDownStartLog = useCallback(
      (wp, type, code) => {
        dispatch(
          logging({
            category: 'Wallpaper',
            action: 'R_Wallpaper_D_Sd',
            label: '',
            param2: {
              source: `${logInfoData.source}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              wptype: type || 1,
              wallpaperId: wp?.wallpaperId,
              wallpaperCode: code,
            },
            param3: wallpaper?.bizInfo || '{}',
          }),
        );
      },
      [logInfoData, wallpaper],
    );

    const handleNativedownImg = useCallback(() => {
      // 判断是否是第一次设置
      try {
        const isFirst =
          window?.external?.inde_get_kivi(JSON.stringify({ ki: WP_DOWNLOAD })) || '""';
        const result = (JSON.parse(isFirst) || {}).vi;

        if (!result) {
          setWpProduct(state => ({
            ...state,
            hasSetPath: false,
          }));
          return;
        } else {
          setWpProduct(state => ({
            ...state,
            hasSetPath: true,
          }));
        }
      } catch (err) {
        logNative(`获取是否是第一次下载壁纸失败：${err}`);
      }
      setIsDownloading(true);
      // 下载打桩

      const countKey = wallpaper?.type === 2 ? `pk_${wallpaper?.code}` : wallpaper?.wallpaperId;
      dispatch(
        updateWpPayDownCount({
          [countKey]: wallpaper?.type === 2 ? wallpaper?.wallpapers?.length : 1,
          type: 'add',
        }),
      );
      if (wallpaper?.type === 2) {
        Promise.allSettled(
          wallpaper?.wallpapers.map(item => {
            return new Promise((resolve, reject) => {
              handelWpDownStartLog(item, 2, wallpaper?.code);
              PCStoreJsBridge.requestWpBuyDownload({
                url: item?.wallpaperImg[2].uri, // 下载壁纸的URL
                id: item?.wallpaperId,
                type: `${'setWpDownload'}__${wallpaper?.code}`,
                code: '',
                bizinfo: item.bizInfo || '{}',
              })
                .then(res => {
                  if (res.succ) {
                    dispatch(
                      addDownloadImg({
                        wallpaper: {
                          ...item,
                          type: `${'setWpDownload'}__${wallpaper?.code}`,
                          id: item.wallpaperId,
                        },
                      }),
                    );
                  }
                  resolve(res);
                })
                .catch(err => {
                  reject(err);
                });
            });
          }),
        ).then(
          results => {
            logNative(`壁纸批量下载请求接口： ${JSON.stringify(results)}`);
          },
          err => {
            Toast.error({
              content: JSON.stringify(err),
            });
          },
        );
      } else {
        handelWpDownStartLog(wallpaper, 1, null);
        PCStoreJsBridge.requestWpBuyDownload({
          url: wallpaper?.wallpaperImg[2].uri, // 下载壁纸的URL
          id: wallpaper?.wallpaperId,
          type: 'setWpDownload',
          code: '',
          bizinfo: wallpaper.bizInfo || '{}',
        })
          .then(res => {
            if (!res.succ) {
              Toast.error({
                content: res?.msg,
              });
            } else {
              dispatch(
                addDownloadImg({
                  wallpaper: {
                    ...wallpaper,
                    type: 'setWpDownload',
                    id: wallpaper.wallpaperId,
                    status: 1,
                  },
                }),
              );
            }
          })
          .catch(err => {
            Toast.error({
              content: JSON.stringify(err),
            });
          });
      }
    }, [wallpaper]);

    const handleWPDownBtnLog = useCallback(() => {
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'C_Wallpaper_Download',
          label: '',
          param2: {
            source: `${logInfoData.source}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wptype: wallpaper.type,
            wallpaperId: wallpaper.type !== 2 ? wallpaper.wallpaperId : wallpaper.code,
          },
          param3: wallpaper?.bizInfo || '{}',
        }),
      );
    }, [wallpaper, logInfoData]);

    const callbackTurnOrder = useCallback(
      async flag => {
        if (flag) {
          handledownImg();
        }
      },
      [loginStatus, wallpaper, wpProduct],
    );

    const handledownImg = useCallback(async () => {
      handleWPDownBtnLog();
      callback({
        actionType: 'C_Wallpaper_Download',
        wptype: wallpaper.type,
        wallpaperId: wallpaper.type !== 2 ? wallpaper.wallpaperId : wallpaper.code,
      });
      dispatch(showBatchAddInfo(false));
      if (!loginStatus) {
        setWpTask(state => ({ ...state, down: true }));
        handleLogin();
        return;
      }
      setWpTask(state => ({ ...state, down: false }));
      //  壁纸已购买 由于需要变态的处理无网络的情况，只有让免费限免下载的壁纸也去走一次是否购买的判断，从而判断有无网络
      // if (wpProduct?.hasBuy || wallpaper?.needCheckBeforeDownload === 0) {
      if (wpProduct?.hasBuy) {
        // 直接触发下载
        handleNativedownImg();
        return;
      } else {
        const hasBuy = await getBuyStatus();
        if (hasBuy === -1) {
          // 是否已购买  1.未购买 引导购买 2.购买 触发下载
          setWpProduct(state => ({
            ...state,
            show: true,
          }));
          dispatch(
            updateShowWpOrder({
              show: true,
              wallpaperId: wallpaper.type !== 2 ? wallpaper?.wallpaperId : '',
              code: wallpaper.type === 2 ? wallpaper.code : '',
              wpType: wallpaper.type !== 2 ? 1 : 2, // 1: 单张壁纸，2：壁纸包
              wallpaper: wallpaper,
              cardInfo: cardInfo,
              logInfo: logInfo,
              callbackTurnOrder: callbackTurnOrder,
              scenetype: 'dl', // 'set', 'dl', 'resident', 'loop_single', 'loop_batch', 'loop_start'
            }),
          );
        } else if (hasBuy === 1) {
          handleNativedownImg();
          //  触发发下载
        } else {
          failToast();
        }
      }
    }, [loginStatus, wallpaper, wpProduct]);

    const handleCloseDownPath = useCallback(() => {
      setWpProduct(state => ({ ...state, hasSetPath: true }));
      handleNativedownImg();
    }, [loginStatus, wallpaper, wpProduct, logInfoData]);

    /**
     * price :价格单位是分
     */
    const handlePrice = useCallback(price => {
      return parseFloat(+price / 100);
    }, []);

    // 寻找壁纸包或则单张壁纸是否是在下载中的状态
    useEffect(() => {
      // status 0:等待 1下载中 2下载完成 3 下载失败 4.
      // 单张壁纸
      if (wallpaper.type !== 2) {
        const target = wpDownloadImgs?.find(wp => {
          return wp.type === 'setWpDownload' && wp.id === wallpaper?.wallpaperId;
        });
        if (target) {
          const result = [0, 1].indexOf(target?.status) > -1;
          setIsDownloading(!!result);
        } else {
          setTimeout(() => {
            setIsDownloading(false);
          }, 200);
        }
      } else {
        setTimeout(() => {
          setIsDownloading(false);
        }, 6000);
        // 壁纸包
        // 1.找出属于壁纸包的壁纸
        const targets = JSON.parse(
          JSON.stringify(
            wpDownloadImgs
              ?.filter(wp => {
                return wp.type === `${'setWpDownload'}__${wallpaper.code}`;
              })
              ?.filter(wp => [0, 1, 2, 3].indexOf(wp.status) > -1),
          ),
        );
        // 所有壁纸加入下载队列
        if (targets && targets.length > 0 && targets.length < wallpaper?.wallpapers?.length) {
          setIsDownloading(true);
        }

        if (!targets || targets.length !== wallpaper?.wallpapers?.length) {
          return;
        }

        // 1.判断是否含有下载中的壁纸
        const result = targets.find(wp => {
          return [0, 1].indexOf(wp.status) > -1;
        });
        setIsDownloading(!!result);
      }
    }, [wpDownloadImgs, wallpaper]);
    useActivate(() => {
      if (wallpaper.type !== 2) {
        const target = wpDownloadImgs?.find(wp => {
          return wp.type === 'setWpDownload' && wp.id === wallpaper?.wallpaperId;
        });
        if (target) {
          const result = [0, 1].indexOf(target?.status) > -1;
          setIsDownloading(!!result);
        }
      } else {
        // 壁纸包
        // 1.找出属于壁纸包的壁纸
        const targets = JSON.parse(
          JSON.stringify(
            wpDownloadImgs
              ?.filter(wp => {
                return wp.type === `${'setWpDownload'}__${wallpaper.code}`;
              })
              ?.filter(wp => [0, 1, 2, 3].indexOf(wp.status) > -1),
          ),
        );
        // 所有壁纸加入下载队列
        if (!targets || targets.length === 0) {
          setIsDownloading(false);
          return;
        } else {
          setIsDownloading(true);
        }
      }
    });

    /**
     * 初始化是否购买状态
     */
    useEffect(() => {
      if (wallpaper?.type == 2) {
        setWpProduct(state => ({
          ...state,
          hasBuy: wallpaper?.hasBuy === 1 ? true : false,
        }));
      }
    }, [wallpaper]);

    // 登录状态发生变化，点赞收藏状态发生变化
    useEffect(() => {
      setWpProduct(state => ({
        ...state,
        hasBuy: false,
      }));
      if (loginStatus && wpTask.down) {
        handledownImg();
      }
    }, [loginStatus]);

    return (
      <>
        <div className={`${styles.btn} ${className}`} onClick={handledownImg}>
          {!isDownloading && hasDownloading && <>{children}</>}
          {/* {!hasDownloading && !isDownloading && (
            <div className={`${styles['btn_' + (wallpaper?.type === 2 ? 'pk_' : '') + size]}`} />
          )} */}
          {!hasDownloading && !isDownloading && (
            <>
              {wallpaper?.type === 2 && size === 'small' && (
                <div className={styles[`btn_pk_small`]}>
                  <span className={`icon iconfont icon-wp_dl ${styles.btn_icon}`}></span>
                  <span className={styles.btn_text}>下载壁纸包</span>
                </div>
              )}
              {wallpaper?.type !== 2 && size === 'small' && (
                <div className={styles[`btn_small`]}>
                  <span className={`icon iconfont icon-wp_dl ${styles.btn_icon}`}></span>
                  <span className={styles.btn_text}>下载壁纸</span>
                </div>
              )}
              {wallpaper?.type !== 2 && size === 'big' && (
                <div className={styles[`btn_big`]}>
                  <span className={`icon iconfont icon-wp_dl ${styles.btn_icon}`}></span>
                  <span className={styles.btn_text}>下载壁纸</span>
                </div>
              )}
            </>
          )}
          {!hasDownloading && isDownloading && (
            <div className={`${styles['btn_' + size + '_load']}`} />
          )}

          {isDownloading && hasDownloading && <div className={styles.btn_loading}>下载中</div>}
          {hasDownloading && !wpProduct?.hasBuy && (
            <div className={styles.price}>
              <div className={styles.price_box}>
                <div className={styles.price_bg_point} />
                <div className={styles.now_price}>
                  <span>&#165;</span>
                  <span>{handlePrice(wallpaper.nowPrice || wallpaper.originalPrice)}</span>
                </div>
                {wallpaper.nowPrice && (
                  <div className={styles.origin_price}>
                    <span>&#165;</span>
                    <span>{handlePrice(wallpaper.originalPrice)}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {/* {wpProduct?.show && (
          <WpProductDetail
            wallpaper={{ ...wallpaper, type: wallpaper.type || 1 }}
            handleClose={() => {
              setWpProduct({ ...wpProduct, show: false });
            }}
          />
        )} */}

        {!wpProduct?.hasSetPath && (
          <WpProductDownloadPath handleCancelDialog={handleCloseDownPath} wallpaper={wallpaper} />
        )}
      </>
    );
  },
);
